import React from 'react';
import Viewer from '../../Viewer';
import { extConfig } from '../../../Editor/presets/Status/config';
import type { ExternalReactRenderers } from '../../../Editor/types';
import cn from 'classnames';
import { Measureable } from '../../types';

import s from './Status.scss';

export interface Props extends Measureable {
  contentJson: any;
  className?: string;
  externalRenderers: ExternalReactRenderers;
  presetId?: string;
}

const StatusViewer = React.forwardRef<HTMLDivElement, Props>(
  ({ contentJson, className, externalRenderers, cookieType, defaultSize, presetId }, ref) => {
    return (
      <Viewer
        presetId={presetId ?? 'deviation-status'}
        contentJson={contentJson}
        className={cn(s['root'], s[`preset-${presetId}`], className)}
        extensionConfig={extConfig}
        externalRenderers={externalRenderers}
        cookieType={cookieType}
        defaultSize={defaultSize}
        ref={ref}
      />
    );
  }
);
StatusViewer.displayName = 'StatusViewer';

export default StatusViewer;
